import React from 'react';
import { withTranslations, WithTranslations } from '../../../utils/withTranslations';
import { TemplatesStore } from '../../stores/TemplatesStore';
import { ScreenStore } from '../../stores/ScreenStore';
import { injectStoresV1 } from '../../stores/injectStoresV1';
import { newFlowPreviewDataHooks } from './NewFlowPreview.dataHooks';
import s from './NewFlowPreview.scss';
import { SaveTemplateButton } from './SaveTemplateButton/SaveTemplateButton';
import { BackToListButton } from './BackToListButton/BackToListButton';
import { ReadMoreButton } from './ReadMoreButton/ReadMoreButton';

export interface NewFlowPreviewProps extends WithTranslations {
  dataHook?: string;
  templatesStore: TemplatesStore;
  screenStore: ScreenStore;
}

const NewFlowPreviewCmp: React.FC<NewFlowPreviewProps> = ({ dataHook, templatesStore, screenStore }) => {
  const [frameContentHeight, setFrameContentHeight] = React.useState<number | null>(null);
  const handleFrameLoaded = (e: React.SyntheticEvent<HTMLIFrameElement>) => {
    const contentHeight = e.currentTarget.contentWindow.document.body.scrollHeight;
    setFrameContentHeight(contentHeight);
  };

  const title = `Preview of website ${templatesStore.expandedTemplate?.title}`;

  return (
    <section className={s.container} data-hook={dataHook}>
      <header className={s.header}>
        <BackToListButton dataHook={newFlowPreviewDataHooks.backToListButton()} />
        <SaveTemplateButton dataHook={newFlowPreviewDataHooks.saveTemplateButton()} />
      </header>
      <div className={s.scrollContainer}>
        <iframe
          title={title}
          data-hook={newFlowPreviewDataHooks.iframe()}
          src={screenStore.previewIframeUrl}
          key={templatesStore.expandedTemplate?.id}
          className={s.frame}
          onLoad={handleFrameLoaded}
          style={{ height: frameContentHeight ? `${frameContentHeight}px` : '100%' }}
        />
        <footer className={s.footer}>
          <ReadMoreButton dataHook={newFlowPreviewDataHooks.readMoreButton()} />
        </footer>
      </div>
    </section>
  );
};

export const NewFlowPreview = withTranslations(injectStoresV1('screenStore', 'templatesStore')(NewFlowPreviewCmp));
